<template>
    <div v-if="show" class="mask">
        <div  class="form-modal doc-edit-modal flex flex-col flex-space-between book">
            <div class="flex flex-space-between flex-center-cz title border-box">
                <div v-if="isNew && isNew == true" class="margin-left-l font-s">插入测试问题</div>
                <div v-else class="margin-left-l font-s">编辑测试问题</div>
                <img src="@/assets/images/guanbi.png" class="logo-18 margin-right-m pointer" @click="close"/>
            </div>
            
            <vue-custom-scrollbar class="flex flex-col body padding-top-l border-box " style="height: calc(100% - 100px)" >
                <div class="flex flex-col margin-top-m">
                    <div class="flex">
                        <div class="flex flex-center-cz  edit-area margin-top-m">
                            <div class="label">责任人</div>
                            <div class="value"> <input placeholder="填写负责解决该问题的人员"  class="ui-input full-width" type="text" v-model="formData.dutyPerson" /></div>
                        </div>
                        <div class="flex flex-center-cz  edit-area margin-top-m">
                            <div class="label">优先级</div>
                            <div class="value"><MySelect v-model="formData.level" :data="levelData" :value="'中'" :result="''"></MySelect> </div>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="flex flex-center-cz  edit-area margin-top-m">
                            <div class="label">系统版本</div>
                            <div class="value"> <input placeholder="填写测试问题对应的版本号" class="ui-input full-width" type="text" v-model="formData.verNo" /></div>
                        </div>
                        <div class="flex flex-center-cz  edit-area margin-top-m">
                            <div class="label">标签</div>
                            <div class="value"> <input placeholder="用于分类" class="ui-input full-width" type="text" v-model="formData.tag" /></div>
                        </div>
                    </div>

                    <div class="flex flex-center-cz  edit-area margin-top-m" style="width: 1005px;">
                        <div class="label">问题描述</div>
                        <div class="value"> <RichText  ref="rtf"  class="full-width" v-model="formData.content" :plus="false"   /></div>
                    </div>

                </div>
            </vue-custom-scrollbar>
            <div class="flex flex-center-sp flex-center-cz toolbar border-box"> 
                <div class="margin-right-s ui-print-button flex flex-center-cz flex-center-sp" @click="confirm">确定</div>         
            </div>
        </div>
    </div>
</template>

<script>
    import RichText from '@/components/richText/RichText' 
    import MySelect from '@/components/select/Select' 
    import {getHtmlData} from '@/api/api.js';   
    import { objToStr } from '../../utils/sysUtils';
   

    export default {
        name:'DocShowModal',
        created() {
        },
        components:{RichText,MySelect},
        data() {
            return {
                show: null,
                isNew: false,
                formData:{},
                levelData:[
                    {
                        text:"高",
                        value:'高',
                    },
                    {
                        text:"中",
                        value:'中',
                    },
                    {
                        text:"低",
                        value:"低",
                    },

                ],
                userName : sessionStorage.getItem("realname"),
                userId : sessionStorage.getItem("userId"),
            }
        },
        methods:{
            showForm(data) {
                this.isNew = false;
                this.$showLoading();
                getHtmlData(data.dataId).then((res) => {
                    if (res.data.success == true) {
                        this.formData = res.data.result;
                        this.show = true;
                        this.$closeLoading(); 

                    }             
                })         
            },
            newForm(data) {
                this.formData = data;
                this.isNew = true;
                this.show = true;
            },
            confirm() {
                console.log(this.formData);
                if (objToStr(this.formData.content) ==="") {
                    this.$showToast({
                        msg: '内容描述未填写' 
                    }) 
                    return false;
                }

                if (objToStr(this.formData.tag) ==="") {
                    this.formData.tag = "-"
                }
                if (objToStr(this.formData.verNo) ==="") {
                    this.formData.verNo = "-"
                }
                if (objToStr(this.formData.dutyPerson) ==="") {
                    this.formData.dutyPerson = "-"
                }
                if (objToStr(this.formData.level) ==="") {
                    this.formData.level = "-"
                }

                if (this.isNew) {
                    this.$emit("add", this.formData)
                } else {
                    this.$emit("update", this.formData)
                }
                
            },
            close() {
                this.show = false;
            },
            
            

        }
   }
</script>

<style scoped>

    .form-modal {
        top: 25px;
    }
    .doc-edit-modal {
        width: 1070px;
        height: 810px;
    }
    .edit-area {
       width: 500px;
    }
 


    .body .row {
        line-height: 40px;
    }
</style>


// WEBPACK FOOTER //
// src/views/plugs/InsertTestModal.vue